import type React from 'react';
import useModal from 'hooks/useModal';
import { WalletOnboarding } from './WalletOnboarding.component';

export type UseWalletOnboardingModalAPI = {
  open: (initialScreenIndex?: number) => void;
  close: () => void;
};

type UseWalletOnboardingModalReturn = [
  React.ReactNode,
  UseWalletOnboardingModalAPI,
];

const useWalletOnboardingModal = (): UseWalletOnboardingModalReturn => {
  const [modalContent, modalApi] = useModal({
    width: '2xl',
    name: 'wallet-onboarding-modal',
    color: 'bank',
    className: '!max-w-[40rem]',
  });

  const api: UseWalletOnboardingModalAPI = {
    open: (initialScreenIndex?: number) => {
      modalApi.open(() => (
        <WalletOnboarding
          initialScreenIndex={initialScreenIndex}
          onClose={modalApi.close}
        />
      ));
    },
    close: modalApi.close,
  };

  return [modalContent, api];
};

export default useWalletOnboardingModal;
